import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-0" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "form-custom dialog-custom__content" }
const _hoisted_4 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommandIconComponent = _resolveComponent("CommandIconComponent")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom",
    style: {"max-width":"1125px"}
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.CommandIcon")), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_CommandIconComponent, {
          defaultSettings: _ctx.defaultSettings,
          "onUpdate:defaultSettings": _cache[1] || (_cache[1] = ($event: any) => (_ctx.defaultSettings = $event)),
          deviceName: "",
          readonly: true
        }, null, 8, ["defaultSettings"])
      ]),
      _createVNode("footer", _hoisted_4, [
        _createVNode(_component_Button, {
          class: "p-button-rounded",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Close")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}